import { ScreenRecordingBridgeClient } from '../../serviceworkerBridgeClients/ScreenRecordingBridgeClient';

/**
 * MediaAssessmentTaskDoneController is a class that manages the behavior of a media assessment task completion screen.
 * It handles the timeout for quitting the task and provides a method to manually quit the task.
 * 
 * @class
 * @param {Object} $scope - The AngularJS scope object.
 * @param {Object} $timeout - The AngularJS $timeout service.
 * @param {Object} BridgeRuntimeService - The service responsible for runtime operations.
 * @param {Object} TaskInfoService - The service responsible for providing task information.
 */
export class MediaAssessmentTaskDoneController {
    /**
     * Constructs a new instance of MediaAssessmentTaskDoneController.
     * 
     * @constructor
     * @param {Object} $scope - The AngularJS scope object.
     * @param {Object} $timeout - The AngularJS $timeout service.
     * @param {Object} BridgeRuntimeService - The service responsible for runtime operations.
     * @param {Object} TaskInfoService - The service responsible for providing task information.
     * @param {Object} ScreenRecordingBridgeClient - The service responsible for screen recording operations.
     */
    constructor($scope, $timeout, BridgeRuntimeService, TaskInfoService, ScreenRecordingBridgeClient) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.BridgeRuntimeService = BridgeRuntimeService;
        this.TaskInfoService = TaskInfoService;
        this.ScreenRecordingBridgeClient = ScreenRecordingBridgeClient;

        // Retrieve task information and bind it to the scope
        this.initializeTaskInfo();

        // Set up a timeout to quit the task after 30 seconds
        this.setupQuitTimeout();

        // Bind the onQuit method to the current instance
        this.$scope.onQuit = this.onQuit.bind(this);
    }

    /**
     * Initializes the task information and binds it to the scope.
     * 
     * @method
     */
    initializeTaskInfo() {
        const taskInfo = this.TaskInfoService.getTaskInfo();
        this.$scope.taskInfo = taskInfo;
    }

    /**
     * Sets up the timeout to quit the task after 30 seconds.
     * 
     * @method
     */
    setupQuitTimeout() {
        this.quitTimeout = this.$timeout(() => {
            this.ScreenRecordingBridgeClient.stopRecording();
        }, 30000);
    }

    /**
     * Handles the manual quit action.
     * This method cancels the automatic quit timeout and then quits the task.
     * 
     * @method
     */
    onQuit() {
        // Cancel the automatic quit timeout
        this.$timeout.cancel(this.quitTimeout);

        // Quit the task
        this.BridgeRuntimeService.quit(false);
    }
}

export default function registerMediaAssessmentTaskDoneController(angular) {
    const module = angular.module('assessmentFrontendControllers');
    module.controller('MediaAssessmentTaskDoneController', ['$scope', '$timeout', 'BridgeRuntimeService', 'TaskInfoService', 'ScreenRecordingBridgeClient', MediaAssessmentTaskDoneController]);
}
